<div class="bcg p-4 ">
    <div class="row">
      <div class="col-lg-6 col-sm-6 col-md-6">
        <p class="nav_link_cat  ms-1">
          <span class="clickable" (click)="gotoDashboard()">Dashboard</span>
          <span [style.font-weight]="'bold'"> >> </span>
          <span>Wallet</span>
          <span [style.font-weight]="'bold'"> >> </span>
          <span class="clickable" [routerLink]="['/doqfy/wallet/amount-balance']">Amount Balance</span>
          <span [style.font-weight]="'bold'"> >> </span>
          <span class="clickable" [routerLink]="['/doqfy/wallet/expenditure']" >Expenditure</span>
          <span [style.font-weight]="'bold'"> >> </span>
          <span>View</span>
         
        </p>
            </div>
      <div class="col-lg-3 col-sm-3 col-md-3 "></div>
      <div class="col-lg-3 col-sm-3 col-md-3 overlay text-right">
        <app-select-branch></app-select-branch>
      </div>
     </div>
     <div  class="card card_outLine mt-3">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6 col-sm-6 col-md-6">
                    <h5 class="title_five">State wise expenditure</h5>
                    <p class="card-text text_p ">Expenditure of the  State Details</p>
                </div>
            <div class="col-lg-6 col-sm-6 col-md-6 text-right custom_button">
                <p-button label="Export Excel" (click)="export()" icon="bx bx-export"   styleClass="p-button-sm-outline"></p-button>
                <p-button class="ms-1" label="Back" [routerLink]="['/doqfy/wallet/expenditure']"    styleClass="p-button-sm-outline"></p-button>
              
                         </div>
            </div>
                    </div>
      </div>
     <div  class="card card_outLine mt-3">
         <div class="card-body">
            <div class="row">
                <div class="col-lg-3 col-sm-3 col-md-3">
                    <h5 class="title_five">Total Deposit : {{amountbalance}}</h5>
                </div>
              
                    <div class="col-lg-2 col-sm-2 col-md-2 form_inputFields_1">
                        <app-search-input placeholder="Search here"></app-search-input>
                    </div>
                    <div class="col-lg-2 col-sm-2 col-md-2 overlay_1">
                        <app-dropdown  class="custom-dropdown text-left" [options]="states" [(ngModel)]="selectedState" (click)= getSelected() placeholder= {{displayBranch}} optionValue="name"  optionLabel="name"></app-dropdown>

                    </div>
                    <div class="col-lg-2 col-sm-2 col-md-2 overlay_1">
                        <app-dropdown  class="custom-dropdown text-left" [options]="denomination" [(ngModel)]="selectedDenomination" placeholder="Select Denomination"  optionLabel="label"></app-dropdown>

                    </div>
                    <div class="col-lg-2 col-sm-2 col-md-2 overlay">
                            <span>
                            <p-datepicker class="custom-calendar"[(ngModel)]="selectedDate" icon="bx bxs-calendar"  placeholder="Select Month" view="month" dateFormat="MM yy"
                            [showIcon]="true" iconDisplay="input"  [readonlyInput]="false" inputId="monthpicker">
                               </p-datepicker>
                              </span>
                    </div>
                    <div class="col-lg-2 col-sm-2 col-md-2 text-right">
                        <app-column-chooser [table]="dataTable"></app-column-chooser>
                    </div>

            </div>
            <div class="row m-2">
                <app-data-table
                    #dataTable
                    [columnChooser]="true"
                    [columns]="columns"
                    [data]="expenditure"
                    [paginator]="false">
                    <ng-template appTableCell="denomination" let-row>
                        ₹ {{ row.denomination }}
                    </ng-template>
                </app-data-table>
            </div>
                     </div>
       </div>
    
    

</div>